<div class="review-header">
  <div class="review-header__text">
    <span class="review-header__eyebrow">
      {{ 'GNR_EXTRACTION_REVIEW_EYEBROW' | translate }}
    </span>
    <span class="review-header__title">
      {{ 'GNR_EXTRACTION_REVIEW_TITLE' | translate }}
    </span>
    @if (state() === 'ready') {
      <span class="review-header__subtitle">
        {{ 'GNR_EXTRACTION_REVIEW_SUBTITLE' | translate }}
      </span>
    }
  </div>

  <button class="review-header__close" mat-icon-button matDialogClose>
    <mat-icon>close</mat-icon>
  </button>

  @if (fileName || state() === 'ready') {
    <div class="review-header__meta">
      @if (fileName) {
        <span class="meta-pill meta-pill--file">
          <mat-icon>description</mat-icon>
          <span class="meta-pill__text">{{ fileName }}</span>
        </span>
      }
      @if (state() === 'ready') {
        <span class="meta-pill meta-pill--count">
          <mat-icon>auto_awesome</mat-icon>
          <span class="meta-pill__text">
            {{
              'GNR_EXTRACTION_REVIEW_FIELD_COUNT' | translate: [rows().length]
            }}
          </span>
        </span>
      }
    </div>
  }
</div>

<mat-dialog-content class="review-body">
  @switch (state()) {
    @case ('waiting') {
      <div class="state-panel">
        <mat-spinner diameter="32"></mat-spinner>
        <p>{{ 'GNR_EXTRACTING_DATA_FROM_DOCUMENT' | translate }}</p>
        <p class="state-panel__hint">
          {{ 'GNR_EXTRACTION_REVIEW_LEAVE_HINT' | translate }}
        </p>
      </div>
    }

    @case ('unreadable') {
      <div class="state-panel">
        <mat-icon class="state-panel__icon">error_outline</mat-icon>
        <p>{{ 'GNR_EXTRACTION_UNREADABLE' | translate }}</p>
      </div>
    }

    @case ('timedOut') {
      <div class="state-panel">
        <mat-icon class="state-panel__icon">schedule</mat-icon>
        <p>{{ 'GNR_EXTRACTION_STILL_RUNNING' | translate }}</p>
        <p class="state-panel__hint">
          {{ 'GNR_EXTRACTION_STILL_RUNNING_HINT' | translate }}
        </p>
      </div>
    }

    @case ('nothingToReview') {
      <div class="state-panel">
        <mat-icon class="state-panel__icon">check_circle_outline</mat-icon>
        <p>{{ 'GNR_EXTRACTION_REVIEW_NO_CHANGES' | translate }}</p>
      </div>
    }

    @case ('ready') {
      <div class="review-section__title">
        <span>{{ 'GNR_EXTRACTION_REVIEW_SECTION' | translate }}</span>
        <button mat-button type="button" (click)="selectAll('document')">
          {{ 'GNR_EXTRACTION_REVIEW_TAKE_ALL' | translate }}
        </button>
        <button mat-button type="button" (click)="selectAll('current')">
          {{ 'GNR_EXTRACTION_REVIEW_KEEP_ALL' | translate }}
        </button>
      </div>

      <table class="review-table">
        <thead>
          <tr>
            <th>{{ 'GNR_FIELD' | translate }}</th>
            <th>{{ 'GNR_EXTRACTION_REVIEW_CURRENT' | translate }}</th>
            <th>{{ 'GNR_EXTRACTION_REVIEW_DOCUMENT' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.key) {
            <tr
              [class.review-table__row--changing]="
                row.selection === 'document'
              ">
              <td class="review-table__label">{{ row.label }}</td>

              <td>
                <mat-radio-group
                  class="value-choice"
                  [value]="row.selection"
                  (change)="select(row.key, $event.value)">
                  <mat-radio-button
                    class="value-choice__option"
                    [class.value-choice__option--selected]="
                      row.selection === 'current'
                    "
                    value="current"
                    [disabled]="row.isCurrentEmpty">
                    @if (row.isCurrentEmpty) {
                      <span class="value-choice__empty">
                        {{ 'GNR_EXTRACTION_REVIEW_EMPTY' | translate }}
                      </span>
                    } @else {
                      {{ row.currentDisplay }}
                    }
                  </mat-radio-button>
                </mat-radio-group>
              </td>

              <td>
                <mat-radio-group
                  class="value-choice"
                  [value]="row.selection"
                  (change)="select(row.key, $event.value)">
                  <mat-radio-button
                    class="value-choice__option"
                    [class.value-choice__option--selected]="
                      row.selection === 'document'
                    "
                    value="document">
                    {{ row.documentDisplay }}
                  </mat-radio-button>
                </mat-radio-group>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  }
</mat-dialog-content>

<mat-dialog-actions class="review-footer">
  @if (state() === 'ready') {
    <div class="review-footer__stat">
      <span class="review-footer__stat-num">
        {{ selectedFromDocumentCount() }}
      </span>
      <span>
        {{ 'GNR_EXTRACTION_REVIEW_STAT_LABEL' | translate: [rows().length] }}
      </span>
    </div>
  } @else {
    <span></span>
  }

  <div class="review-footer__actions">
    <button mat-stroked-button type="button" (click)="cancel()">
      {{ 'GNR_CANCEL' | translate }}
    </button>
    <button
      mat-flat-button
      type="button"
      class="qt-dialog-primary-button"
      [disabled]="state() !== 'ready' || selectedFromDocumentCount() === 0"
      (click)="confirm()">
      <span>{{ 'CMD_SAVE' | translate }}</span>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</mat-dialog-actions>
